(ns admin.events.containers.activity.overview
  (:require [kyber.router :refer [ensure-resource-v2]]
            [kyber.events.eql :as eql]
            [kyber.events.utils :refer [kyber-event-fx]]
            [re-frame.core :as re-frame]
            [kyber.lib.kyber-db :as kyber-db]))

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-success
    {:description "Get container page success"
     :changelog
     [{:date "18JUN21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-success
  [{:keys [db]} [event-name _ {activity :>/activity curriculum :>/curriculum}]]
  {:db (-> db
           (kyber-db/tx-record {:model :activity} activity)
           (kyber-db/tx-record {:model :curriculum} curriculum))
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-success fetch-container-data-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-failure
    {:description "Get container page failure"
     :changelog
     [{:date "18JUN21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-failure
  [{:keys [db]} [event-name _ _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-failure fetch-container-data-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data
    {:description "Get container page request"
     :changelog
     [{:date "18JUN21"
       :event-version 0
       :data {}}]}))

(def learning-objective-sub-query
  [:learning-objective/uuid
   :learning-objective/description
   :learning-objective/label
   :learning-objective/ordinal])

(defn fetch-container-data
  [{:keys [db]} [event-name {:keys [curriculum-uuid activity-uuid] :as params}]]
  (let [resources-sub-query [:activity/uuid
                             :resource/uuid
                             :resource/created-at
                             :resource/created-by
                             :resource/download-key
                             :resource/download-path
                             :resource/duration
                             :resource/description
                             :resource/failed?
                             :resource/file-name
                             :resource/file-size
                             :resource/file-type
                             :resource/name
                             :resource/page-count
                             :resource/page-dimensions
                             :resource/processing?
                             :resource/source-key
                             :resource/source-path
                             :resource/status
                             :resource/url
                             :resource/m3u8
                             :resource/viewer-key
                             :resource/viewer-path
                             {:resource/learning-objective learning-objective-sub-query}]

        assessment-sub-query [{:assessment/questions
                               [:question/uuid
                                :question.context/uuid
                                {:question.context/learning-objective
                                 [:learning-objective/uuid]}]}]
        questionnaire-sub-query [:questionnaire/uuid
                                 {:questionnaire/questions
                                  [:question/uuid
                                   :question.context/uuid
                                   {:question.context/learning-objective
                                    [:learning-objective/uuid]}]}]]
    {:db db
     :dispatch-n [[:analytics/save-datapoint {:event event-name
                                              :event-version 0}]]
     :request
     (eql/request
      db
      {:name event-name
       :params `[{(:>/activity {:curriculum/uuid ~curriculum-uuid
                                :activity/uuid ~activity-uuid})
                  [:activity/uuid
                   :activity/plo-type
                   :activity/external-activity-link
                   :activity/name
                   :activity/published
                   :activity/ai-enabled
                   {:activity/assessment ~assessment-sub-query}
                   {:activity/evaluation ~questionnaire-sub-query}
                   {(:activity/moments {:include-invalid? true})
                    [:moment/uuid
                     {:moment/learning-objective
                      [:learning-objective/uuid
                       :learning-objective/description
                       :learning-objective/label]}]}
                   {:activity/learning-objectives ~learning-objective-sub-query}
                   {:activity/primary-learning-object ~resources-sub-query}
                   {:activity/resources ~resources-sub-query}]}
                 {(:>/curriculum {:curriculum/uuid ~curriculum-uuid})
                  [:curriculum/uuid
                   :curriculum/name
                   :curriculum/compliance-enabled]}]
       :on-success [::fetch-container-data-success params]
       :on-failure [::fetch-container-data-failure params]})}))

(kyber-event-fx ::fetch-container-data fetch-container-data)

(def ensure-container
  (partial ensure-resource-v2 ::fetch-container-data
           #(re-frame/dispatch [::fetch-container-data %])))
